import React, { FC, MouseEvent } from "react";
import classNames from "classnames";

import { Button, Icon } from "../common";
import {
  useRemoveContactMutation,
  useResendContactLinkMutation,
} from "../../store/services/contacts";
import { Contact, ContactStatus } from "../../types/ContactTypes";
import { toastError, toastSuccess } from "../../utils/toasts";
import { errorMessagesFromResponse } from "../../utils/errors";

type Props = {
  data: Contact;
  closeDropdown?: () => any;
  onErrorRetry?: () => void;
  popover?: boolean;
};

export const ContactsTableDropdown: FC<Props> = ({
  data,
  closeDropdown,
  onErrorRetry,
  popover = true,
}) => {
  const showResendAction = data?.status !== ContactStatus.Verified;

  const [removeContact] = useRemoveContactMutation();
  const [resendContact] = useResendContactLinkMutation();

  const deleteHandler = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    removeContact(data)
      .unwrap()
      .then(() => toastSuccess("Contact deleted successfully"))
      .catch((error) => errorMessagesFromResponse(error).forEach(toastError))
      .finally(closeDropdown);
  };

  const resendHandler = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    resendContact({ id: data?.id })
      .unwrap()
      .then(() => toastSuccess("Invitation resent successfully"))
      .catch((error) => {
        if (error.status === 404) {
          onErrorRetry && onErrorRetry();
        } else {
          errorMessagesFromResponse(error).forEach(toastError);
        }
      })
      .finally(closeDropdown);
  };

  return (
    <div
      className={classNames(
        popover ? "popover-dropdown-menu w-52" : "dropdown-menu"
      )}
    >
      {showResendAction && (
        <Button
          contentClassName="dropdown-menu-item flex flex-row justify-between"
          onClick={resendHandler}
          variant={Button.variant.TERTIARY}
        >
          Resend
          <Icon icon="Send" size={24} className="text-gray-500" disableFill />
        </Button>
      )}

      <Button
        contentClassName="dropdown-menu-item flex flex-row justify-between"
        onClick={deleteHandler}
        variant={Button.variant.TERTIARY}
      >
        Delete
        <Icon icon="Delete" size={24} className="text-gray-500" disableFill />
      </Button>
    </div>
  );
};
